"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rocket = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Rocket = function Rocket() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24.217 2.105l-.32-.32a2.662 2.662 0 00-1.878-.787h-2.024a10.648 10.648 0 00-7.526 3.12l-1.624 1.628-.493.586H7.954c-.838 0-1.628.396-2.13 1.067l-4.662 6.228a.654.654 0 000 .867l1.811 1.814a1.996 1.996 0 002.944-.134l.12-.146 3.889 3.894-.147.12a2.001 2.001 0 00-.133 2.947l1.811 1.814c.247.219.619.219.866 0l6.22-4.668a2.668 2.668 0 001.065-2.134v-2.267l.586-.56 1.625-1.627a10.676 10.676 0 003.184-7.535V3.985a2.669 2.669 0 00-.786-1.88zm-6.66 6.348a2.67 2.67 0 01.585 2.908 2.664 2.664 0 01-4.925 0 2.67 2.67 0 01.584-2.908 2.661 2.661 0 013.756 0zM6.837 20.802a.64.64 0 00-.201-.467l-.946-.947a.639.639 0 00-.932 0l-3.53 3.534a.667.667 0 000 .947l.933.934a.666.666 0 00.945 0l3.53-3.534a.64.64 0 00.202-.467z",
    clipRule: "evenodd"
  });
};

exports.Rocket = Rocket;